export const formatMoney = ( amount: number ): string => {
	const rounded = Math.round( amount * 100 ) / 100;
	return Number.isInteger( rounded ) ? `${rounded}` : rounded.toFixed( 2 );
};
